// ref: https://css-tricks.com/converting-color-spaces-in-javascript/
export const hexToRGB = (hex) => {
    let r = 0, g = 0, b = 0;
    if (hex.length == 4) {
        r = parseInt("0x" + hex[1] + hex[1], 16);
        g = parseInt("0x" + hex[2] + hex[2], 16);
        b = parseInt("0x" + hex[3] + hex[3], 16);
    }
    else if (hex.length == 7) {
        r = parseInt("0x" + hex[1] + hex[2], 16);
        g = parseInt("0x" + hex[3] + hex[4], 16);
        b = parseInt("0x" + hex[5] + hex[6], 16);
    }
    return { r, g, b };
};
//# sourceMappingURL=hexToRGB.js.map